export const authFullBackground = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1968.081"
    height="893.399"
    viewBox="0 0 1968.081 893.399"
  >
    <g id="Group_798" data-name="Group 798" transform="translate(9.32 -53.537)">
      <g
        id="Group_144"
        data-name="Group 144"
        transform="translate(962.82 -838.43)"
      >
        <path
          id="Path_34"
          data-name="Path 34"
          d="M267.921,21.494V7.461A3.962,3.962,0,0,0,263.96,3.5h-23.1A3.962,3.962,0,0,0,236.9,7.461V21.513l31.021-.02Z"
          transform="translate(699.187 901.668)"
          fill="#00ff82"
        />
        <path
          id="Path_35"
          data-name="Path 35"
          d="M33.821,21.494V7.461A3.962,3.962,0,0,0,29.86,3.5H6.761A3.962,3.962,0,0,0,2.8,7.461V17.532a3.962,3.962,0,0,0,3.961,3.961Z"
          transform="translate(962.12 888.467)"
          fill="#00ff82"
        />
      </g>
      <g
        id="Layer_1"
        data-name="Layer 1"
        transform="translate(1664.722 242.978)"
      >
        <g id="Layer_1-2" data-name="Layer 1" transform="translate(0 0)">
          <path
            id="Path_11"
            data-name="Path 11"
            d="M16.584,20.466V4.524c0-2.5-.95-4.524-2.127-4.524H2.127C.95,0,0,2.02,0,4.524V15.987c0,2.5.95,4.524,2.127,4.524l14.457-.044Z"
            fill="#00ff82"
          />
        </g>
      </g>
      <g id="Layer_1-3" data-name="Layer 1" transform="translate(1310 827.105)">
        <g id="Layer_1-4" data-name="Layer 1">
          <path
            id="Path_11-2"
            data-name="Path 11"
            d="M13.745,16.964V3.749C13.745,1.675,12.958,0,11.982,0H1.763C.787,0,0,1.675,0,3.749v9.5C0,15.326.787,17,1.763,17l11.982-.036Z"
            fill="#00ff82"
          />
        </g>
      </g>
      <g
        id="Layer_1-5"
        data-name="Layer 1"
        transform="translate(161.047 311.4)"
      >
        <g id="Layer_1-6" data-name="Layer 1">
          <path
            id="Path_11-3"
            data-name="Path 11"
            d="M13.745,16.964V3.749C13.745,1.675,12.958,0,11.982,0H1.763C.787,0,0,1.675,0,3.749v9.5C0,15.326.787,17,1.763,17l11.982-.036Z"
            fill="#00ff82"
          />
        </g>
      </g>
      <path
        id="Path_16"
        data-name="Path 16"
        d="M273.327,24.629V8.152A4.652,4.652,0,0,0,268.675,3.5H241.552A4.652,4.652,0,0,0,236.9,8.152v16.5l36.427-.023Z"
        transform="translate(-246.22 204.438)"
        fill="#00ff82"
      />
      <path
        id="Path_17"
        data-name="Path 17"
        d="M39.227,24.629V8.152A4.652,4.652,0,0,0,34.575,3.5H7.452A4.652,4.652,0,0,0,2.8,8.152V19.978a4.652,4.652,0,0,0,4.652,4.652Z"
        transform="translate(18.994 187.106)"
        fill="#00ff82"
      />
      <path
        id="Path_31"
        data-name="Path 31"
        d="M276.717,26.6V8.585A5.085,5.085,0,0,0,271.633,3.5H241.985A5.085,5.085,0,0,0,236.9,8.585V26.621l39.817-.025Z"
        transform="translate(139.273 649.879)"
        fill="#00ff82"
      />
      <path
        id="Path_26"
        data-name="Path 26"
        d="M0,16.283V3.585C0,1.605,1.949,0,4.352,0H29.727c2.4,0,4.352,1.605,4.352,3.585V16.3L0,16.283Z"
        transform="translate(1715.132 278.671) rotate(180)"
        fill="#00ff82"
      />
      <path
        id="Path_28"
        data-name="Path 28"
        d="M236.9,17V6.471c0-1.641,1.615-2.971,3.607-2.971h21.032c1.992,0,3.607,1.33,3.607,2.971v10.54L236.9,17Z"
        transform="translate(438.736 344.484) rotate(180)"
        fill="#00ff82"
      />
      <path
        id="Path_27"
        data-name="Path 27"
        d="M236.9,19.783V7.085c0-1.98,1.949-3.585,4.352-3.585h25.375c2.4,0,4.352,1.605,4.352,3.585V19.8L236.9,19.783Z"
        transform="translate(1395.166 225.59)"
        fill="#00ff82"
      />
      <path
        id="Path_23"
        data-name="Path 23"
        d="M236.9,28.04V8.9a5.4,5.4,0,0,1,5.4-5.4h31.5a5.4,5.4,0,0,1,5.4,5.4V28.067L236.9,28.04Z"
        transform="translate(-91.039 918.87)"
        fill="#00ff82"
      />
      <path
        id="Path_21"
        data-name="Path 21"
        d="M2.8,19.137V6.943A3.443,3.443,0,0,1,6.243,3.5H26.316a3.443,3.443,0,0,1,3.443,3.443v8.752a3.443,3.443,0,0,1-3.443,3.443Z"
        transform="translate(1525.695 475.863)"
        fill="#00ff82"
      />
      <path
        id="Path_32"
        data-name="Path 32"
        d="M42.617,26.6V8.585A5.085,5.085,0,0,0,37.533,3.5H7.885A5.085,5.085,0,0,0,2.8,8.585V21.511A5.085,5.085,0,0,0,7.885,26.6Z"
        transform="translate(407.383 630.934)"
        fill="#00ff82"
      />
      <path
        id="Path_22"
        data-name="Path 22"
        d="M2.8,23.938V8A4.5,4.5,0,0,1,7.3,3.5H33.535a4.5,4.5,0,0,1,4.5,4.5V19.438a4.5,4.5,0,0,1-4.5,4.5Z"
        transform="translate(282.527 176.887)"
        fill="#00ff82"
      />
      <path
        id="Path_24"
        data-name="Path 24"
        d="M2.8,25.377V8.316A4.817,4.817,0,0,1,7.616,3.5H35.7a4.817,4.817,0,0,1,4.816,4.816V20.561A4.817,4.817,0,0,1,35.7,25.377Z"
        transform="translate(679.054 90.237)"
        fill="#00ff82"
      />
      <path
        id="Path_25"
        data-name="Path 25"
        d="M2.8,27.97V8.887A5.387,5.387,0,0,1,8.187,3.5H39.6a5.387,5.387,0,0,1,5.387,5.387v13.7A5.387,5.387,0,0,1,39.6,27.97Z"
        transform="translate(76.014 479.265)"
        fill="#00ff82"
      />
      <path
        id="Path_30"
        data-name="Path 30"
        d="M2.8,27.97V8.887A5.387,5.387,0,0,1,8.187,3.5H39.6a5.387,5.387,0,0,1,5.387,5.387v13.7A5.387,5.387,0,0,1,39.6,27.97Z"
        transform="translate(174.277 762.243)"
        fill="#00ff82"
      />
      <path
        id="Path_33"
        data-name="Path 33"
        d="M2.8,27.97V8.887A5.387,5.387,0,0,1,8.187,3.5H39.6a5.387,5.387,0,0,1,5.387,5.387v13.7A5.387,5.387,0,0,1,39.6,27.97Z"
        transform="translate(1896.107 840.605)"
        fill="#00ff82"
      />
      <path
        id="Path_29"
        data-name="Path 29"
        d="M2.8,28.04V8.9A5.4,5.4,0,0,1,8.2,3.5H39.7a5.4,5.4,0,0,1,5.4,5.4V22.637a5.4,5.4,0,0,1-5.4,5.4Z"
        transform="translate(91.328 894.303)"
        fill="#00ff82"
      />
    </g>
  </svg>
);
